module.exports = __webpack_public_path__ + "img/f81789a311ca4a451dda3cf139568fe3.41a5cb62.png";